export default __webpack_public_path__ + "static/media/image12.5d4f7b6d.jfif";